import dayjs from 'dayjs';
import { useSessionStorage } from 'usehooks-ts';
import { useRouter } from 'next/router';
import { cn } from '@discover-lib/utils';
import { DATE_FORMAT_DAY_JS } from '@discover-lib/dateFormats';
import Button from '@discover-ui/button';
import type { RestaurantToShow } from '@discover-data/stores/restaurant/model/types';
import useDate from '@discover-data/stores/hooks/date/useDate';
import usePeople from '@discover-data/stores/hooks/people/usePeople';

export type RegularAvailabilityButtonProps = {
  restaurant: Pick<RestaurantToShow, 'slug' | 'title'>;
  className?: string;
};

function RegularAvailabilityButton({ restaurant, className }: RegularAvailabilityButtonProps) {
  const [, setGuests] = useSessionStorage('guests', 2);
  const today = dayjs().format(DATE_FORMAT_DAY_JS);
  const [, setSelectedDate] = useSessionStorage('date', today);
  const [people] = usePeople();
  const [date] = useDate();
  const router = useRouter();

  return (
    <Button
      kind="gray"
      scale="sm"
      className={cn(
        'w-full text-wrap rounded-sm bg-blue-50 text-center font-medium leading-normal',
        'aspect-[6.392/1] sm:aspect-[7/1] lg:aspect-[4.48/1]',
        className
      )}
      onClick={() => {
        setGuests(people);
        setSelectedDate(date === 'week' ? today : date);
        router.push(`${restaurant.slug}#regular-table`);
      }}>
      <span>
        Browse and book a&nbsp;<strong>Regular Table</strong>&nbsp;at any time
        {restaurant.title && ` at ${restaurant.title}`}
      </span>
    </Button>
  );
}

export default RegularAvailabilityButton;
